/**
 * Whitelabel helper functions for managing dynamic theming
 */

/**
 * Update CSS custom properties for whitelabel theming
 * @param {string} primaryColor - The primary color hex value
 */
export function updateWhitelabelTheme(primaryColor) {
  if (primaryColor) {
    // Convert hex to RGB for rgba usage
    const rgb = hexToRgb(primaryColor);
    if (rgb) {
      document.documentElement.style.setProperty('--primary-color', primaryColor);
      document.documentElement.style.setProperty('--primary-color-rgb', `${rgb.r}, ${rgb.g}, ${rgb.b}`);
    }
  }
}

/**
 * Convert hex color to RGB
 * @param {string} hex - Hex color string
 * @returns {Object|null} RGB object or null if invalid
 */
function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

/**
 * Reset whitelabel theme to default
 */
export function resetWhitelabelTheme() {
  document.documentElement.style.setProperty('--primary-color', '#007bff');
  document.documentElement.style.setProperty('--primary-color-rgb', '0, 123, 255');
}
